export default __webpack_public_path__ + "3af2a05de70f02b6d18caed96acfe995.jpeg";